import React from 'react';
import { Container, Typography, Box, Button, Grid } from '@mui/material';
import {
  Timer as TimerIcon,
  PeopleAlt as PeopleAltIcon,
  Discount as DiscountIcon,
  Warning as WarningIcon,
  Help as HelpIcon,
  SportsGymnastics as SportsGymnasticsIcon,
  FmdBad as FmdBadIcon,
  CardMembership as CardMembershipIcon,
} from '@mui/icons-material';

const infoCards = [
  {
    icon: <HelpIcon fontSize="inherit" />,
    title: 'Välj Rätt Klass',
    text: 'Är du osäker på vilken klass som passar dig? Se vår klassbeskrivning eller prata med en instruktör — vi hjälper dig gärna.',
  },
  {
    icon: <CardMembershipIcon fontSize="inherit" />,
    title: 'Frysning & Återaktivering',
    text: 'Frys ditt medlemskap för 150 kr. Samma avgift tillkommer vid återaktivering. Undantag gäller vid sjukintyg.',
  },
  {
    icon: <TimerIcon fontSize="inherit" />,
    title: 'Personlig Träning',
    text: 'Avbokning krävs minst 24 timmar före PT-pass. Sen avbokning debiteras fullt.',
  },
  {
    icon: <FmdBadIcon fontSize="inherit" />,
    title: 'Strumpor Obligatoriskt',
    text: 'Alla deltagare ska bära strumpor på klasserna. Vi säljer strumpor i flera prisklasser.',
  },
  {
    icon: <PeopleAltIcon fontSize="inherit" />,
    title: 'Klass Avbokning',
    text: 'Vi förbehåller oss rätten att ställa in klasser med för få deltagare.',
  },
  {
    icon: <DiscountIcon fontSize="inherit" />,
    title: 'Visdomsrabatt',
    text: 'Gäller för dig som är under 18 eller över 65 år.',
  },
  {
    icon: <SportsGymnasticsIcon fontSize="inherit" />,
    title: 'Reformer Klasser',
    text: 'Endast för dig som gått Reformer-intro eller har PT-erfarenhet. Säkerhet först!',
  },
  {
    icon: <WarningIcon fontSize="inherit" />,
    title: 'Åldersgräns',
    text: 'Vi välkomnar dig som är 15 år eller äldre till våra klasser.',
  },
];

const BraAttVeta = () => (
  <Container sx={{ py: { xs: 4, md: 6 } }}>
    <Typography
      variant="h3"
      align="center"
      sx={{
        fontWeight: 'bold',
        color: '#007C85',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        mb: 6,
      }}
    >
      Bra att veta
    </Typography>

    <Grid container spacing={4}>
      {infoCards.map((card, i) => (
        <Grid item xs={12} sm={6} key={i}>
         <Box
            sx={{
              px: 4,
              py: 5,
              background: 'rgba(255, 255, 255, 0.6)',
              backdropFilter: 'blur(14px)',
              border: '1px solid rgba(0, 0, 0, 0.04)',
              borderRadius: '20px',
              boxShadow: '0 10px 28px rgba(0,0,0,0.04)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              transition: 'all 0.3s ease',
              maxWidth: '500px',
              margin: '0 auto',
              minHeight: '130px',
              '&:hover': {
                transform: 'translateY(-6px)',
                boxShadow: '0 14px 30px rgba(0,0,0,0.08)',
              },
            }}
          >
            <Box
              sx={{
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                background: 'linear-gradient(145deg, #fdfcfc, #f1f9f9)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)',
                fontSize: '2rem',
                mb: 2,
                color: '#A2257C',
              }}
            >
              {card.icon}
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#444', mb: 1 }}>
              {card.title}
            </Typography>
            <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.7 }}>
              {card.text}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>

    <Box
      sx={{
        mt: 6,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'center',
        alignItems: 'center',
        marginTop:'2rem',
        gap: 2,
      }}
    >
      <Button
        href="/sidepages/klasses"
        sx={{
           background: 'linear-gradient(135deg, #00b5bf, #429398)',
          color: '#fff',
          px: 4,
          py: 1.5,
          borderRadius: '999px',
          fontWeight: 600,
          fontSize: '1rem',
          textTransform: 'none',
          boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
          '&:hover': {
                      transform: 'translateY(-2px)',
                      background: 'linear-gradient(135deg, #007C85, #357f87)',
                    },
        }}
      >
        Se Alla Klasser
      </Button>
      <Button
        href="/sidepages/membership-info"
        sx={{
           background: 'linear-gradient(135deg, #A2257c,rgb(100, 22, 77))',
          color: '#fff',
          px: 4,
          py: 1.5,
          borderRadius: '999px',
          fontWeight: 600,
          fontSize: '1rem',
          textTransform: 'none',
          boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
          boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.1)',
            '&:hover': {
                      transform: 'translateY(-2px)',
                      background: 'linear-gradient(135deg,rgb(120, 29, 93), rgb(72, 16, 55))',
                    },
        }}
      >
        Köp Medlemskap
      </Button>
    </Box>
  </Container>
);

export default BraAttVeta;
